import { LucideChevronDown, LucideChevronUp } from 'lucide-react'
import { aUser, useAtomValue } from '~/atoms'
import { Button, Separator } from '~/components/ui'
import { useLocalStorage } from '~/hooks'
import { PROPERTY_TYPES_COLORS, cn } from '~/utils'

export default function MapLegend({ className }: { className?: string }) {
  const user = useAtomValue(aUser)
  const [isLegendVisible, setIsLegendVisible] = useLocalStorage(
    'isLegendVisible',
    true
  )

  return (
    <div
      id="map-legend"
      className={cn(
        'w-26 absolute right-4 rounded-md bg-background text-xs shadow-md',
        user ? 'bottom-20' : 'bottom-6',
        className
      )}>
      <div className="flex">
        {isLegendVisible === true && (
          <div className="space-y-1 px-2 py-1" id="legend-content">
            <div className="flex items-center gap-2">
              <span className="legend-triangle" />
              <span className="text-xs">Sale</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 rounded-full bg-[#c026d3]" />
              <span className="text-xs">Lease</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 bg-[#4f46e5]" />
              <span className="text-xs">Sale/Lease</span>
            </div>
            <Separator className="!my-2" />
            {PROPERTY_TYPES_COLORS.map(({ propertyType, className }, index) => (
              <div key={index} className="flex items-center gap-2">
                <span className={cn('h-3 w-3 rounded-full', className)} />
                <span className="text-xs">{propertyType}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <Button
        variant="ghost"
        onClick={() => setIsLegendVisible((prev) => !prev)}
        className="h-8 w-full justify-start px-1.5 text-xs">
        {isLegendVisible === true ? (
          <>
            <LucideChevronDown className="mr-1.5 h-4 w-4 pl-px" /> Hide Legend
          </>
        ) : (
          <>
            <LucideChevronUp className="mr-1.5 h-4 w-4 pl-px" /> Show Legend
          </>
        )}
      </Button>
    </div>
  )
}
